module.exports = __webpack_public_path__ + "img/12_wind.d3da4cb9.jpg";